<template>
	<div
		:style="updateQueWithSection ? 'margin-top: -45px;' : 'margin-top: -30px;'"
		style="text-transform: capitalize"
	>
		<div
			v-if="updateQueWithSection"
			style="
				display: grid;
				width: 100%;
				grid-template-columns: auto 1fr auto;
				align-items: center;
				margin-bottom: 5px;
			"
			class="button-container"
		>
			<el-button
				:disabled="current_category_index == 0"
				@click="prev_category()"
				icon="el-icon-caret-left"
				style="
					background: #ffffff;
					border-radius: 12px;
					color: #d26300;
					border: 1px solid #d26300;
				"
			>
				Prev
			</el-button>
			<div style="font-size: 15px; font-weight: bold; text-align: center">
				{{ current_category_item.form_category_info.name }}
			</div>
			<el-button
				:disabled="tableDataActiveCategory.length - 1 == current_category_index"
				style="
					background: #ffffff;
					border-radius: 12px;
					color: #d26300;
					border: 1px solid #d26300;
				"
				@click="next_category()"
				icon="el-icon-caret-right"
			>
				Next
			</el-button>
		</div>
		<div style="display: grid; width: 100%; grid-template-columns: 15% 1fr 15%">
			<div style="grid-column: 2">
				<el-card shadow="none">
					<div
						style="display: grid; grid-template-columns: 80% 20%; width: 100%"
					>
						<div style="font-size: 14px; font-weight: bold">
							<u>{{ formDetails.form_info.name }}</u>
						</div>
						<!--  -->
						<div v-if="yes_no_count != 0" style="text-align: right">
							<b>
								Points -
								{{
									Question_form_Details.scoring_type == "all_pass"
										? all_pass_current_question_points
										: current_question_points
								}}
								of
								{{
									Question_form_Details.scoring_type == "all_pass"
										? Question_form_Details.total_points
										: total_points
								}}
							</b>
						</div>
					</div>
					<div
						style="
							display: grid;
							gap: 10px;
							width: 100%;
							align-items: center;
							margin-top: 10px;
						"
						:style="
							formDetails.form_info.show_mark_all_yes_no
								? 'grid-template-columns: repeat(5, 1fr)'
								: 'grid-template-columns: repeat(3, 1fr)'
						"
					>
						<div
							v-if="formDetails.form_info.show_mark_all_yes_no"
							@click="button_condition_yes_to_all()"
							style="
								width: 100%;
								height: 40px;
								text-align: center;
								border-radius: 12px;
								border-color: #d26300;
								color: #d26300;
								border: 1px solid;
								cursor: pointer;
							"
							:style="green_color"
						>
							<div style="padding-top: 10px">Yes All</div>
						</div>
						<div
							v-if="formDetails.form_info.show_mark_all_yes_no"
							@click="button_condition_no_to_all()"
							style="
								width: 100%;
								height: 40px;
								text-align: center;
								border-radius: 12px;
								border-color: #d26300;
								color: #d26300;
								border: 1px solid;
								cursor: pointer;
							"
							:style="red_color"
						>
							<div style="padding-top: 10px">No All</div>
						</div>
						<div
							@click="clear_all_selection()"
							style="
								width: 100%;
								height: 40px;
								text-align: center;
								color: #d26300;
								border: none;
								cursor: pointer;
							"
						>
							<div style="padding-top: 10px">Clear All</div>
						</div>
						<div style="text-align: right; grid-column: span 2">
							<span style="margin-right: 10px">NA All</span>
							<el-switch
								@change="show_mark_all_na_method"
								v-model="show_mark_all_na"
								active-color="#41BE62"
							></el-switch>
						</div>
					</div>
				</el-card>
				<div
					style="overflow-y: auto"
					:style="updateQueWithSection ? 'height: 55vh;' : 'height: 60vh;'"
				>
					<div
						v-for="(section, sectionIndex) in sortedSections"
						:key="section.section_info.id"
					>
						<h3 style="margin-top: 10px">
							{{ sectionIndex + 1 }}. {{ section.section_info.name }}
						</h3>
						<div style="border: 1px solid" class="my-2"></div>
						<QuestionComponent
							v-for="(question, index) in section.que_list"
							:key="question.id"
							:question="question"
							:sr_no="index"
							:Question_form_Details="Question_form_Details"
							@getImages="getImages"
							@initializeSignaturePad="initializeSignaturePad"
							:project_info_object="project_info_object"
							:allQuestions="allQuestions"
							:update_all="update_all"
							@raise="getRaiseTicketAction"
							:current_question_idx="current_question_idx"
							:countryList="countryList"
							:currentCountryCode="currentCountryCode"
							:sendCountryCode="sendCountryCode"
							:show_buttons="show_buttons"
							:company_details="company_details"
						/>
					</div>
					<div style="margin-top: 10px">
						<QuestionComponent
							v-for="(question, index) in sortedQuestionsWithoutSection"
							:key="question.id"
							:question="question"
							:sr_no="index"
							:Question_form_Details="Question_form_Details"
							@getImages="getImages"
							@initializeSignaturePad="initializeSignaturePad"
							:project_info_object="project_info_object"
							:allQuestions="allQuestions"
							:update_all="update_all"
							@raise="getRaiseTicketAction"
							:current_question_idx="current_question_idx"
							:countryList="countryList"
							:currentCountryCode="currentCountryCode"
							:sendCountryCode="sendCountryCode"
							:show_buttons="show_buttons"
							:company_details="company_details"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="button-container">
			<el-card shadow="none" class="button-card">
				<el-button
					:disabled="
						(company_details.access_level !== 'admin' && !show_buttons) ||
						current_question_idx == 0
					"
					@click="prev_question()"
					icon="el-icon-caret-left"
					:loading="calling_api"
					style="background: #f9a168; border-radius: 12px; color: #ffffff"
				>
					Back
				</el-button>
				<el-button
					:disabled="company_details.access_level !== 'admin' && !show_buttons"
					style="
						background: #ffffff;
						border-radius: 12px;
						color: #d26300;
						border: 1px solid #d26300;
					"
					:loading="calling_api"
					@click="save_n_exit('Section')"
				>
					Save & Exit
				</el-button>
				<el-button
					:disabled="
						(company_details.access_level !== 'admin' && !show_buttons) ||
						tableDataActiveSectionAbout.length - 1 == current_question_idx
					"
					@click="next_question()"
					style="background: #f9a168; border-radius: 12px; color: #ffffff"
					icon="el-icon-caret-right"
					:loading="calling_api"
				>
					Next
				</el-button>
			</el-card>
		</div>
	</div>
</template>

<script>
import QuestionComponent from "./QuestionComponent.vue";
import { EventBus } from "../../../../eventBus";
var moment = require("moment");
import formBuilderServices from "../../../../services/formBuilderServices";
import { Country } from "country-state-city";

export default {
	components: {
		QuestionComponent,
	},
	props: {
		formItemObject: Object,
		formDetails: Object,
		Question_form_Details: Object,
		project_info_object: Object,
		current_category_item: Object,
		calling_api: Boolean,
		current_category_index: Number,
		tableDataActiveCategory: Array,
		current_question_idx: Number,
		tableDataActiveSectionAbout: Array,
		show_buttons: Boolean,
		company_details: Object,
	},
	data() {
		return {
			moment: moment,
			formItemsObjectDetails: {},
			yes_no_count: 0,
			total_points: 0,
			all_pass_current_question_points: 0,
			current_question_points: 0,
			green_color: "",
			red_color: "",
			show_mark_all_na: false,
			initializeSignaturePad: {},
			getImages: {},
			QueWithSection: false,
			allQuestions: [],
			update_all: false,
			currentCountryCode: null,
			countryList: [],
			sendCountryCode: false,
		};
	},
	async mounted() {
		console.log(this.company_details, "company_details");
		this.sendCountryCode = false;
		await this.getCountryInfo();
		this.formItemsObjectDetails = this.formItemObject;
	},
	computed: {
		sortedSections() {
			return this.sortAndInitializeSections(
				this.formItemObject.que_with_section
			);
		},
		sortedQuestionsWithoutSection() {
			return this.sortAndInitialize(this.formItemObject.que_without_section);
		},
		updateQueWithSection() {
			return this.formItemObject.que_with_section.length != 0
				? (this.QueWithSection = true)
				: false;
		},
		async getAllQuestions() {
			await Promise.all(
				this.sortedSections.map(async (section) => {
					await Promise.all(
						section.que_list.map(async (question) => {
							await this.pushAllQuestions(question);
						})
					);
				})
			);
			await Promise.all(
				this.sortedQuestionsWithoutSection.map(async (question) => {
					await this.pushAllQuestions(question);
				})
			);
			return this.allQuestions;
		},
	},
	methods: {
		async getCountryInfo() {
			try {
				const CountryList = Country.getAllCountries();
				this.countryList = CountryList.map((country) => ({
					...country,
					phonecode: country.phonecode.startsWith("+")
						? country.phonecode
						: `+${country.phonecode}`,
				}));
				const response = await fetch(
					"https://api.geoapify.com/v1/ipinfo?&apiKey=2822bc2b5cf94eb5aab6e98a047ba9dc"
				);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const {
					country: { name },
				} = await response.json();
				const country = this.countryList.find((el) => el.name === name);
				if (country) {
					let { phonecode } = country;
					if (!phonecode.startsWith("+")) {
						phonecode = `+${phonecode}`;
					}
					this.currentCountryCode = phonecode;
					this.sendCountryCode = true;
					this.$forceUpdate();
				} else {
					console.warn("Country not found in CountryList");
				}
			} catch (error) {
				console.error("Error fetching country info:", error.message);
			}
		},
		getRaiseTicketAction(item) {
			if (item.actions.length == 0) {
				this.current_obj_obj = item;
				this.$emit("raise", item);
			} else {
				alert("Action already raised");
			}
		},
		async button_condition_yes_to_all() {
			this.allQuestions = []; // Initialize the array
			this.update_all = false;
			await Promise.all(
				this.sortedSections.map(async (section) => {
					await Promise.all(
						section.que_list.map(async (question) => {
							await this.pushAllQuestions(question);
						})
					);
				})
			);
			await Promise.all(
				this.sortedQuestionsWithoutSection.map(async (question) => {
					await this.pushAllQuestions(question);
				})
			);
			this.current_question_points = 0;
			this.green_color =
				"color:white; background:#41BE62; border-color:#41BE62";
			this.red_color = "";
			this.allQuestions.forEach((question) => {
				if (question.form_question_info.input_type_info.name === "Yes / No") {
					question.button_yes = true;
					question.boolean_input = true;
					question.button_no = null;
					question.green_color =
						"color:white; background:#41BE62; border-color:#41BE62";
					question.red_color = "";

					if (question.form_question_info.expected_responses_list.length) {
						question.form_question_info.expected_responses_list.forEach(
							(response) => {
								if (response.expected_boolean_value === question.button_yes) {
									question.current_question_points = response.points_on_trigger;
								}
							}
						);
					}

					this.current_question_points += question.current_question_points || 0;
				}
			});
			if (this.Question_form_Details.scoring_type === "all_pass") {
				this.all_pass_current_question_points =
					this.Question_form_Details.total_points;
			}
			this.$set(this.formItemObject, "que_with_section", [
				...this.formItemObject.que_with_section,
			]);
			this.$set(this.formItemObject, "que_without_section", [
				...this.formItemObject.que_without_section,
			]);
			this.update_all = true;
			this.$forceUpdate();
		},
		async button_condition_no_to_all() {
			this.allQuestions = []; // Initialize the array
			this.update_all = false;
			await Promise.all(
				this.sortedSections.map(async (section) => {
					await Promise.all(
						section.que_list.map(async (question) => {
							await this.pushAllQuestions(question);
						})
					);
				})
			);
			await Promise.all(
				this.sortedQuestionsWithoutSection.map(async (question) => {
					await this.pushAllQuestions(question);
				})
			);
			this.current_question_points = 0;
			this.green_color = "";
			this.red_color = "color:white; background:#FF0000; border-color:#FF0000";
			for (let i = 0; i < this.allQuestions.length; i++) {
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Yes / No"
				) {
					this.allQuestions[i].current_question_points = 0;
					this.allQuestions[i].button_yes = null;
					this.allQuestions[i].button_no = true;
					this.allQuestions[i].boolean_input = false;
					this.allQuestions[i].red_color =
						"color:white; background:#FF0000; border-color:#FF0000";
					this.allQuestions[i].green_color = "";
					if (
						this.allQuestions[i].form_question_info.expected_responses_list
							.length != 0
					) {
						for (
							let j = 0;
							j <
							this.allQuestions[i].form_question_info.expected_responses_list
								.length;
							j++
						) {
							if (
								this.allQuestions[i].form_question_info.expected_responses_list[
									j
								].expected_boolean_value != this.allQuestions[i].button_no
							) {
								this.allQuestions[i].current_question_points =
									this.allQuestions[
										i
									].form_question_info.expected_responses_list[
										j
									].points_on_trigger;
							}
						}
					}
					this.current_question_points +=
						this.allQuestions[i].current_question_points != undefined
							? this.allQuestions[i].current_question_points
							: 0;
				}
			}
			if (this.Question_form_Details.scoring_type == "all_pass") {
				this.all_pass_current_question_points = 0;
			}
			this.$set(this.formItemObject, "que_with_section", [
				...this.formItemObject.que_with_section,
			]);
			this.$set(this.formItemObject, "que_without_section", [
				...this.formItemObject.que_without_section,
			]);
			this.update_all = true;
			this.$forceUpdate();
		},
		async show_mark_all_na_method() {
			this.update_all = false;
			this.allQuestions = [];
			await Promise.all(
				this.sortedSections.map(async (section) => {
					await Promise.all(
						section.que_list.map(async (question) => {
							await this.pushAllQuestions(question);
						})
					);
				})
			);
			await Promise.all(
				this.sortedQuestionsWithoutSection.map(async (question) => {
					await this.pushAllQuestions(question);
				})
			);
			for (let i = 0; i < this.allQuestions.length; i++) {
				this.allQuestions[i].marked_as_na = this.show_mark_all_na;
			}
			this.update_all = true;
			this.$forceUpdate();
		},
		async clear_all_selection() {
			this.update_all = false;
			this.allQuestions = [];
			await Promise.all(
				this.sortedSections.map(async (section) => {
					await Promise.all(
						section.que_list.map(async (question) => {
							await this.pushAllQuestions(question);
						})
					);
				})
			);
			await Promise.all(
				this.sortedQuestionsWithoutSection.map(async (question) => {
					await this.pushAllQuestions(question);
				})
			);
			for (let z = 0; z < this.allQuestions.length; z++) {
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ==
					"Yes / No"
				) {
					this.allQuestions[z].boolean_input = null;
					this.allQuestions[z].button_no = null;
					this.allQuestions[z].button_yes = null;
					this.allQuestions[z].red_color = "";
					this.allQuestions[z].green_color = "";
					this.allQuestions[z].current_question_points = 0;
					this.green_color = "";
					this.red_color = "";
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ==
					"Checklist"
				) {
					this.allQuestions[z].checked = null;
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ===
					"Timer"
				) {
					this.allQuestions[z].form_question_info.stopwatches = Array.from(
						{ length: this.allQuestions[z].form_question_info.timer_attempts },
						() => ({
							time: 0, // or whatever default value you want
							isRunning: false, // assuming you have a flag to track stopwatch status
						})
					);
					this.allQuestions[z].form_question_info.showStartButton = Array.from(
						{ length: this.allQuestions[z].form_question_info.timer_attempts },
						() => true
					);
					this.allQuestions[z].form_question_info.showStopButton = Array.from(
						{ length: this.allQuestions[z].form_question_info.timer_attempts },
						() => false
					);
					this.allQuestions[z].form_question_info.showResetButton = Array.from(
						{ length: this.allQuestions[z].form_question_info.timer_attempts },
						() => false
					);
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ===
					"Date"
				) {
					this.allQuestions[z].date_input = null;
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ===
					"Time"
				) {
					this.allQuestions[z].time_input = null;
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ===
					"Datetime"
				) {
					this.allQuestions[z].datetime_input = null;
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ==
					"Rating"
				) {
					this.allQuestions[z].number_input = null;
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ==
					"Select any one"
				) {
					this.allQuestions[z].input_option = null;
					for (
						let i = 0;
						i <
						this.allQuestions[z].form_question_info.input_options_list.length;
						i++
					) {
						this.allQuestions[z].form_question_info.input_options_list[
							i
						].checked = false;
					}
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ==
					"Multiselect"
				) {
					this.allQuestions[z].multiple_input_options = [];
					for (
						let i = 0;
						i <
						this.allQuestions[z].form_question_info.input_options_list.length;
						i++
					) {
						this.allQuestions[z].form_question_info.input_options_list[
							i
						].selected = false;
					}
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ==
						"Long Text" ||
					this.allQuestions[z].form_question_info.input_type_info.name ==
						"Long text" ||
					this.allQuestions[z].form_question_info.input_type_info.name ==
						"Short text" ||
					this.allQuestions[z].form_question_info.input_type_info.name ==
						"Number input" ||
					this.allQuestions[z].form_question_info.input_type_info.name ==
						"Dropdown" ||
					this.allQuestions[z].form_question_info.input_type_info.name ==
						"Mobile number" ||
					this.allQuestions[z].form_question_info.input_type_info.name ==
						"Email"
				) {
					this.allQuestions[z].input_option = null;
					this.allQuestions[z].text_input = null;
					this.allQuestions[z].number_input = null;
				}
				if (
					this.allQuestions[z].form_question_info.input_type_info.name ==
						"Temperature" ||
					this.allQuestions[z].form_question_info.input_type_info.name == "TPM"
				) {
					this.allQuestions[z].number_input = null;
					this.allQuestions[z].repeat_number_input = null;
					this.allQuestions[z].test_color = null;
					this.allQuestions[z].test_color_retest = null;
					this.allQuestions[z].show_temp_retest = false;
					this.allQuestions[z].test_color_tpm = null;
					this.allQuestions[z].test_color_tpm_retest = null;
					this.allQuestions[z].show_tpm_retest = false;
				}
			}
			if (this.Question_form_Details.scoring_type == "all_pass") {
				this.all_pass_current_question_points = 0;
			}
			this.update_all = true;
			this.$forceUpdate();
		},
		async save_n_exit(type) {
			this.allQuestions = [];
			await Promise.all(
				this.sortedSections.map(async (section) => {
					await Promise.all(
						section.que_list.map(async (question) => {
							await this.pushAllQuestions(question);
						})
					);
				})
			);
			await Promise.all(
				this.sortedQuestionsWithoutSection.map(async (question) => {
					await this.pushAllQuestions(question);
				})
			);
			this.saveQuestions(type);
		},
		async pushAllQuestions(question) {
			return new Promise((resolve) => {
				setTimeout(() => {
					this.allQuestions.push(question);
					resolve();
				}, 100);
			});
		},
		saveQuestions(type) {
			this.$emit("calling_api_true");
			let invalidReasons = [];
			const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			this.allQuestions.forEach((question, idx) => {
				if (
					question.form_question_info.is_image_required &&
					question.form_question_execution_attachments.length === 0
				) {
					invalidReasons.push(
						`Upload mandatory image for question '${idx + 1}'`
					);
				}
				if (
					question.form_question_info.is_comment_required &&
					(!question.comment || question.comment.length === 0)
				) {
					invalidReasons.push(
						`Enter mandatory comment for question '${idx + 1}'`
					);
				}
				if (
					question.form_question_info.input_type_info.name == "Mobile number" &&
					question.text_input !== null &&
					question.text_input.toString().length !== 10
				) {
					invalidReasons.push(
						`Mobile number is incorrect for question '${idx + 1}'`
					);
				}
				if (
					question.form_question_info.input_type_info.name == "Email" &&
					question.text_input !== null &&
					!emailPattern.test(question.text_input)
				) {
					invalidReasons.push(
						`Please enter a valid email address for question '${idx + 1}'`
					);
				}
				if (question.form_question_info.is_mandatory) {
					if (
						question.form_question_info.input_type_info.name == "Long Text" ||
						question.form_question_info.input_type_info.name == "Long text" ||
						question.form_question_info.input_type_info.name == "Short text" ||
						question.form_question_info.input_type_info.name ==
							"Mobile number" ||
						question.form_question_info.input_type_info.name == "Email"
					) {
						if (
							question.text_input == null ||
							question.text_input.trim() == ""
						) {
							invalidReasons.push(`Input mandatory for question '${idx + 1}'`);
						}
					}
					if (
						question.form_question_info.input_type_info.name ==
							"Number input" ||
						question.form_question_info.input_type_info.name == "Temperature" ||
						question.form_question_info.input_type_info.name == "TPM" ||
						question.form_question_info.input_type_info.name == "Rating"
					) {
						if (
							question.number_input == null ||
							question.number_input.toString().trim() == ""
						) {
							invalidReasons.push(`Input mandatory for question '${idx + 1}'`);
						}
					}
					if (
						question.form_question_info.input_type_info.name ==
							"Select any one" ||
						question.form_question_info.input_type_info.name == "Dropdown"
					) {
						if (question.input_option == null) {
							invalidReasons.push(`Input mandatory for question '${idx + 1}'`);
						}
					}
					if (
						question.form_question_info.input_type_info.name == "Multiselect"
					) {
						if (question.selected == null) {
							invalidReasons.push(`Input mandatory for question '${idx + 1}'`);
						}
					}
					if (question.form_question_info.input_type_info.name == "Date") {
						if (question.date_input == null) {
							invalidReasons.push(`Input mandatory for question '${idx + 1}'`);
						}
					}
					if (question.form_question_info.input_type_info.name == "Time") {
						if (question.time_input == null) {
							invalidReasons.push(`Input mandatory for question '${idx + 1}'`);
						}
					}
					if (question.form_question_info.input_type_info.name == "Datetime") {
						if (question.datetime_input == null) {
							invalidReasons.push(`Input mandatory for question '${idx + 1}'`);
						}
					}
				}
			});
			if (invalidReasons.length > 0) {
				this.$notify.error({
					title: "Validation Errors",
					message: `
        <ul style="margin-left: -50px;">
            ${invalidReasons.map((reason) => `<li>${reason}</li>`).join("")}
        </ul>`,
					dangerouslyUseHTMLString: true, // Allows HTML rendering
				});
				setTimeout(() => {
					this.$emit("calling_api_false");
				}, 1000);
			} else {
				this.saveQuestionAPI(type);
			}
		},
		async saveQuestionAPI(val) {
			let params = [];
			for (let i = 0; i < this.allQuestions.length; i++) {
				let boolean_input = null;
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Yes / No"
				) {
					if (this.allQuestions[i].button_yes == true) {
						boolean_input = true;
					}
					if (this.allQuestions[i].button_no == true) {
						boolean_input = false;
					}
				}
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Checklist"
				) {
					if (this.allQuestions[i].checked) {
						boolean_input = true;
					} else {
						boolean_input = false;
					}
				}
				let datetime_input = null;
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Datetime"
				) {
					datetime_input =
						this.allQuestions[i].datetime_input != null
							? moment(this.allQuestions[i].datetime_input).format(
									"YYYY-MM-DD HH:mm:ss"
							  )
							: null;
				}
				let date_input = null;
				if (
					this.allQuestions[i].form_question_info.input_type_info.name == "Date"
				) {
					date_input = this.allQuestions[i].date_input;
				}
				let time_input = null;
				if (
					this.allQuestions[i].form_question_info.input_type_info.name == "Time"
				) {
					time_input = this.allQuestions[i].time_input;
				}

				let timer_input = [];
				// let time_count=0;
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Timer"
				) {
					for (
						let j = 0;
						j < this.allQuestions[i].form_question_info.stopwatches.length;
						j++
					) {
						const stopwatch =
							this.allQuestions[i].form_question_info.stopwatches[j];
						if (stopwatch.id && stopwatch.time !== 0) {
							timer_input.push({
								id: stopwatch.id,
								seconds: stopwatch.time / 1000,
								serial_no: j + 1,
							});
						} else if (stopwatch.time !== 0) {
							timer_input.push({
								seconds: stopwatch.time / 1000,
								serial_no: j + 1,
							});
						}
					}
				}
				let text_input = null;
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
						"Long Text" ||
					this.allQuestions[i].form_question_info.input_type_info.name ==
						"Long text"
				) {
					text_input = this.allQuestions[i].text_input;
				}
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Short text"
				) {
					text_input = this.allQuestions[i].text_input;
				}
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Mobile number"
				) {
					if (this.allQuestions[i].text_input != null) {
						text_input =
							this.allQuestions[i].country_number_input +
							"-" +
							this.allQuestions[i].text_input;
					}
				}
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Email"
				) {
					text_input = this.allQuestions[i].text_input;
				}
				let number_input = null;
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Number input"
				) {
					number_input = this.allQuestions[i].number_input;
				}
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Temperature"
				) {
					number_input = this.allQuestions[i].number_input;
				}

				if (
					this.allQuestions[i].form_question_info.input_type_info.name == "TPM"
				) {
					number_input = this.allQuestions[i].number_input;
				}
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Rating"
				) {
					number_input = this.allQuestions[i].number_input;
				}
				let repeat_number_input = null;
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Temperature"
				) {
					repeat_number_input = this.allQuestions[i].repeat_number_input;
				}
				if (
					this.allQuestions[i].form_question_info.input_type_info.name == "TPM"
				) {
					repeat_number_input = this.allQuestions[i].repeat_number_input;
				}
				let input_option = null;
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Select any one"
				) {
					input_option = this.allQuestions[i].input_option;
				}
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Dropdown"
				) {
					input_option = this.allQuestions[i].input_option;
				}
				let form_question_execution_attachments = [];
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Signature"
				) {
					if (
						this.allQuestions[i].form_question_execution_attachments.length != 0
					) {
						for (
							let z = 0;
							z <
							this.allQuestions[i].form_question_execution_attachments.length;
							z++
						) {
							if (
								this.allQuestions[i].form_question_execution_attachments[z].id
							) {
								form_question_execution_attachments = [];
							}
						}
					} else {
						await this.saveSignature(this.allQuestions[i]);
						if (this.allQuestions[i].signaturePadUploaded != undefined) {
							if (this.allQuestions[i].signaturePadUploaded.length != 0) {
								for (
									let z = 0;
									z < this.allQuestions[i].signaturePadUploaded.length;
									z++
								) {
									if (this.allQuestions[i].signaturePadUploaded[z].id) {
										form_question_execution_attachments.push({
											id: this.allQuestions[i].signaturePadUploaded[z].id,
											file_path:
												this.allQuestions[i].signaturePadUploaded[z].file_path,
											file_name:
												this.allQuestions[i].signaturePadUploaded[z].file_name,
										});
									} else {
										form_question_execution_attachments.push({
											file_path:
												this.allQuestions[i].signaturePadUploaded[z].file_path,
											file_name:
												this.allQuestions[i].signaturePadUploaded[z].file_name,
										});
									}
								}
							}
						}
					}
				}
				let multiple_input_options = [];
				if (
					this.allQuestions[i].form_question_info.input_type_info.name ==
					"Multiselect"
				) {
					for (
						let j = 0;
						j <
						this.allQuestions[i].form_question_info.input_options_list.length;
						j++
					) {
						if (
							this.allQuestions[i].form_question_info.input_options_list[j]
								.selected
						) {
							multiple_input_options.push(
								this.allQuestions[i].form_question_info.input_options_list[j].id
							);
						}
					}
				}
				if (this.allQuestions[i].fileURLArray != undefined) {
					if (this.allQuestions[i].fileURLArray.length != 0) {
						for (let z = 0; z < this.allQuestions[i].fileURLArray.length; z++) {
							if (this.allQuestions[i].fileURLArray[z].id) {
								form_question_execution_attachments.push({
									id: this.allQuestions[i].fileURLArray[z].id,
									file_path: this.allQuestions[i].fileURLArray[z].file_path,
									file_name: this.allQuestions[i].fileURLArray[z].file_name,
								});
							} else {
								form_question_execution_attachments.push({
									file_path:
										this.allQuestions[i].form_question_execution_attachments[z]
											.file_path,
									file_name:
										this.allQuestions[i].form_question_execution_attachments[z]
											.file_name,
								});
							}
						}
					}
				}
				params.push({
					form_execution: this.formDetails.id,
					id: this.allQuestions[i].id,
					comment: this.allQuestions[i].comment,
					marked_as_na: this.allQuestions[i].marked_as_na,
					ticket_raised: this.allQuestions[i].ticket_raised, // ticket raised = true : false
					boolean_input: boolean_input,
					text_input: text_input,
					number_input: number_input != null ? Number(number_input) : null,
					repeat_number_input:
						repeat_number_input != null ? Number(repeat_number_input) : null,
					input_option: input_option,
					multiple_input_options: multiple_input_options,
					form_question_execution_attachments:
						form_question_execution_attachments,
					datetime_input: datetime_input,
					timer_input_data: timer_input,
					date_input: date_input,
					time_input: time_input,
				});
			}
			formBuilderServices.submitQuestionInputFromUser(params).then((res) => {
				if (val == "1") {
					this.$emit("next_question");
				}
				if (val == "2") {
					this.$emit("prev_question");
				}
				if (val == "Section") {
					this.$emit("save_filled_question");
				}
				if (val == "5") {
					this.$emit("prev_category", this.current_category_index);
				}
				if (val == "6") {
					this.$emit("next_category", this.current_category_index);
				}
			});
		},
		async saveSignature(question) {
			try {
				const signaturePad = question.signaturePads;
				if (signaturePad) {
					if (signaturePad.isEmpty()) {
						return;
					}
					const dataURL = signaturePad.toDataURL();
					const blob = this.dataURLToBlob(dataURL);
					const file = new File(
						[blob],
						`Signature ${Math.floor(new Date().getTime() / 1000)}.png`,
						{ type: "image/png" }
					);
					const formData = new FormData();
					formData.append("attachments", file);
					formData.append("storage", "task");
					const res = await formBuilderServices.uploadImageAttachment(formData);
					this.$set(
						question,
						"signaturePadUploaded",
						JSON.parse(res.data).data
					);
				}
			} catch (error) {
				console.error("Error in saveSignature:", error);
			}
		},
		dataURLToBlob(dataURL) {
			const binary = atob(dataURL.split(",")[1]);
			const array = [];
			for (let i = 0; i < binary.length; i++) {
				array.push(binary.charCodeAt(i));
			}
			return new Blob([new Uint8Array(array)], { type: "image/png" });
		},
		next_question() {
			this.loading = true;
			this.save_n_exit("1");
		},
		prev_question() {
			this.loading = true;
			this.save_n_exit("2");
		},
		prev_category() {
			this.loading = true;
			this.save_n_exit("5");
		},
		next_category() {
			this.loading = true;
			this.save_n_exit("6");
		},
		sortAndInitialize(items) {
			return items
				.sort(
					(a, b) =>
						a.form_question_info.serial_no - b.form_question_info.serial_no
				)
				.map((question) => {
					const formQuestionInfo = question.form_question_info;
					const inputTypeInfo = formQuestionInfo
						? formQuestionInfo.input_type_info
						: null;

					if (inputTypeInfo && inputTypeInfo.name === "Timer") {
						this.initializeTimerData(question);
					} else if (inputTypeInfo && inputTypeInfo.name === "Yes / No") {
						this.yes_no_count += 1;
					}

					return question;
				});
		},
		sortAndInitializeSections(sections) {
			return sections.map((section) => {
				if (section.que_list && Array.isArray(section.que_list)) {
					section.que_list = this.sortAndInitialize(section.que_list);
				}
				return section;
			});
		},
		initializeTimerData(question) {
			let timerAttempts = question.form_question_info.timer_attempts;
			question.form_question_info.stopwatches = [];
			question.form_question_info.isRunning = [];
			question.form_question_info.showStartButton = [];
			question.form_question_info.showResetButton = [];
			question.form_question_info.showStopButton = [];
			question.form_question_info.interval = [];
			const timerDataLength = question.timer_input_data.length;
			for (let k = 0; k < Math.max(timerAttempts, timerDataLength); k++) {
				if (k < timerDataLength) {
					const timerData = question.timer_input_data[k];
					question.form_question_info.stopwatches.push({
						id: timerData.id || null,
						time: (timerData.seconds || 0) * 1000,
						serial_no: timerData.serial_no || null,
					});
					question.form_question_info.showResetButton.push(!!timerData.id);
					question.form_question_info.showStartButton.push(!timerData.id);
				} else {
					question.form_question_info.stopwatches.push({
						time: 0,
						stopped: false,
					});
					question.form_question_info.showResetButton.push(false);
					question.form_question_info.showStartButton.push(true);
				}
				question.form_question_info.showStopButton.push(false);
				question.form_question_info.isRunning.push(false);
				question.form_question_info.interval.push(0);
			}
		},
	},
};
</script>

<style>
.button-container {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding: 0 15%;
	margin-top: 10px;
}

.button-card {
	display: flex;
	gap: 8px; /* Space between buttons */
	width: 100%;
	justify-content: flex-end;
}
</style>
